import { RoundButton } from '@cian/ui-kit/button';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './SidebarNewbuildingHeader.css';
import { CloseButton } from '../CloseButton';

interface ISidebarNewbuildingHeaderProps {
  favoriteButton?: React.ReactNode;
  onClose(): void;
  isCompareEnabled: boolean;
}

export const SidebarNewbuildingHeader: React.FC<ISidebarNewbuildingHeaderProps> = ({
  favoriteButton,
  onClose,
  isCompareEnabled,
}) => {
  if (isCompareEnabled) {
    return (
      <div className={styles['close-button']}>
        <RoundButton theme="light" size="XS" icon={<IconActionClose12 />} onClick={onClose} title="Закрыть" />
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      {favoriteButton}
      <CloseButton onClick={onClose} />
    </div>
  );
};
